// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { mapShippingCustomCarrier } from "@bg/App/Store/Selectors/Checkout/CheckoutSelectors";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchResetQuotes,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrderForApproval";

const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState() as CustomAppState;
    const { notes, po } = state.xCheckout;
    const carrierInformation = mapShippingCustomCarrier(state);

    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            notes: notes || "",
            poNumber: po || "",
            properties: {
                ...props.apiParameter.cart.properties,
                ...carrierInformation,
            },
        },
    };
};

export const xClearCustomStore: typeof DispatchResetQuotes = props => {
    props.dispatch({
        type: "xCheckout/clearCustomStore",
    } as any);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainAfter(chain, DispatchResetQuotes, xClearCustomStore);
